export enum AppRoute {
  Home = '/',
  Price = '/price',
  Gallery = '/gallery',
  TOS = '/tos',
};
